import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import NamedLink from '../NamedLink/NamedLink';

import css from './ReportListingLink.module.css';

// Small flag icon shown before the link text.
const IconFlag = () => (
  <svg
    className={css.icon}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M2.75 1.25v9.5"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      fill="none"
    />
    <path d="M3.9 1.9h5.35L8.1 3.9l1.15 2H3.9z" fill="currentColor" />
  </svg>
);

/**
 * A quiet "Report listing" text link with a flag icon.
 *
 * Reporting is a rare, non-commercial action, so it is deliberately a text link
 * and not a button: it stays easy to find next to the seller's name or the
 * listing title without competing with the purchase actions (Buy now / Message
 * seller / Make offer).
 *
 * The link points to the Contact Us page, which is the marketplace's channel for
 * reporting inappropriate or suspicious listings.
 *
 * @param {Object} props
 * @param {string?} props.className extra classes, added to the default ones
 * @param {string?} props.rootClassName overrides the default classes
 * @returns {JSX.Element} link element
 */
const ReportListingLink = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <NamedLink className={classes} name="CMSPage" params={{ pageId: 'contact' }}>
      <IconFlag />
      <FormattedMessage id="ReportListingLink.reportListing" />
    </NamedLink>
  );
};

ReportListingLink.propTypes = {
  className: string,
  rootClassName: string,
};

export default ReportListingLink;
